$(document).ready(function() {

  //Détecte le click sur les boutons checkout (panier dynamique à l'ajout d'un produit, boutons page panier)
  $('body').on('click', '.atc-button--checkout', function(e){
    checkIfRunPopup(e);
  });

  //On vérifie que l'utilisateur n'est pas loggé ET que le paramètre qui affiche le popup est actif
  function checkIfRunPopup(e) {
    if (!$('body').hasClass('customer-logged') && $('body').hasClass('display_popup_checkout')){
      showModal();
      e.preventDefault();
    }
  }

  function showModal() {
    $modal = $('.modal');
    $content = $modal.find('.modal-content');
    $('html').addClass('scroll-locked');
    $('body').addClass('modal-loaded modal-visible');
    $modal.addClass('allow-scroll-while-locked modal--before-checkout');
    if ($content.html() == "") {
      $modal.find('.modal-content').append($('#content-checkout-popup').html());
    }
  }

  // Fonction appelée à la fermeture
  function onModalClose() {
    $('html').removeClass('scroll-locked');
    $('.modal').removeClass('allow-scroll-while-locked modal--before-checkout');
  }
  
  // 1. Fermeture via le bouton croix
  $('.modal .modal-close').on('click', function () {
    onModalClose();
  });
  
  // 2. Fermeture en cliquant sur le fond noir
  $('.modal').on('click', function (e) {
    // Vérifie si le clic est en dehors de .modal-inner
    if (!$(e.target).closest('.modal-inner').length) {
      onModalClose();
    }
  });

  $('body').on('click', '.redirect-checkout', function(){
    $('.redirect-to-checkout').click();
  });
  

  

  //Fonction pour handleiser les textes
  function handleize(str) {
    return str
      .toLowerCase()
      .trim()
      .normalize("NFD")                     // décompose les accents
      .replace(/[\u0300-\u036f]/g, '')     // supprime les accents
      .replace(/[^a-z0-9]+/g, '-')         // remplace les caractères non alphanumériques par des tirets
      .replace(/^-+|-+$/g, '');            // supprime les tirets en début et fin
  }

  //Si on est en page Pay Later (pour les Pro)
  if ($('#cml_checkout_start').length > 0) {
    
    //On charge le texte personnalisé
    var edit_location_text = $('#cml_edit_location_text').attr('content');
    var btn1_label = $('#cml_btn1_label').attr('content');
    var loading_label = $('#cml_loading_label').attr('content');
    $('#cml_checkout_start').find('.shipping_address_widget').append('<div class="full-box location-details"><p>'+edit_location_text+'</p></div>');

    //
    $('#cml_checkout_start').find('.main #place_order').attr("value", btn1_label);
    $('#cml_checkout_start').find('.main .shipping_charges').html(loading_label);
  }
  
  //Fonction qui gère l'affichage de la section "Modal Text Enrichi"
  function openModal(el, modalSelector, contentId) {
    const $modal = $(modalSelector);
    const $modalContent = $modal.find("[data-modal-content]");
    const $sourceContent = el.find(`#${contentId}`);

    if (!$modal.length || !$modalContent.length || !$sourceContent.length) {
      console.error("Modal ou contenu source introuvable.");
      return;
    }

    // Vider le contenu existant
    $modalContent.empty();

    // Remplir le contenu avec les données
    $modalContent.html($sourceContent.html());

    // Afficher le modal
    $('body').addClass('modal-loaded modal-visible');
    $("body").css("overflow", "hidden");
    $modal.addClass("dynamic-section modal--quickshop-full allow-scroll-while-locked");
    console.log('modal loaded');
    
  }

  // Fonction pour fermer le modal
  function closeModal($modal) {
    $('body').removeClass('modal-loaded modal-visible');
    $("body").css("overflow", "");
    $modal.removeClass("dynamic-section modal--quickshop-full allow-scroll-while-locked");

    // Vider le contenu pour éviter des conflits avec d'autres modals
    $modal.find("[data-modal-content]").empty();
  }

  // Gérer l'ouverture du modal
  $(".modal-open-button").on("click", function (e) {
    e.stopImmediatePropagation();
    e.preventDefault();
    const $this = $(this).parents('.rich-text--section.in-modal');
    const modalSelector = $(this).attr("data-modal-trigger");
    const contentId = $(this).attr("data-modal-content-id");

    openModal($this, modalSelector, contentId);
  });

  // Gérer la fermeture du modal
  $("[data-modal-container]").each(function () {
    const $modal = $(this);

    // Bouton de fermeture
    $modal.find("[data-modal-close]").on("click", function () {
      closeModal($modal);
    });

    // Fermer en cliquant à l'extérieur du contenu
    $modal.on("click", function (e) {
      if ($(e.target).is($modal)) {
        closeModal($modal);
      }
    });
  });


  function loadMagnificPopup() {
    // Si la fonction Magnific Popup existe déjà, ne rien faire
    if (typeof $.fn.magnificPopup === 'function') {
      console.log('Magnific Popup est déjà chargé.');
      return;
    }
    
    var script = document.createElement('script');
    // Ajout d'un timestamp pour éviter le cache
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/jquery.magnific-popup.min.js?v=' + new Date().getTime();
    document.head.appendChild(script);
    
    script.onload = function() {
      console.log('Magnific Popup rechargé dynamiquement.');
      if (typeof $.fn.magnificPopup === 'function') {
        // Initialiser les popups sur les éléments ciblés
        $('.popup-video').magnificPopup({
          type: 'iframe'
        });
      } else {
        // Si, 100 ms plus tard, la fonction n'est toujours pas définie, afficher un avertissement
        setTimeout(function() {
          if (typeof $.fn.magnificPopup === 'function') {
            $('.popup-video').magnificPopup({
              type: 'iframe'
            });
          } else {
            console.warn("Magnific Popup n'est toujours pas disponible après le chargement.");
          }
        }, 100);
      }
    };
  }


  /*
  //Gestion des popup vidéo grâce au plugin Magnific Popup (Youtube et Insuu)
  function loadMagnificPopup() {
    var script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/jquery.magnific-popup.min.js?v=' + new Date().getTime();
    document.head.appendChild(script);
    script.onload = function() {
      console.log('Magnific Popup rechargé dynamiquement.');
        
      if (typeof $.fn.magnificPopup === 'function') {
        $('.popup-video').magnificPopup({
          type: 'iframe',
        });
      } else {
        setTimeout(loadMagnificPopup, 100); // Réessayer après 100 ms
      }
    }
  }
  */

  if ($('.popup-video').length > 0) {
    loadMagnificPopup()
  }



  //Toogle du block double login dans le menu principal
  $('a.site-header_account-link-anchor').on('click', function(e){
    const $wrapper_login = $(this).parents().find('.site-header-actions');
    const $wrapper_trigger_login = $wrapper_login.find('.site-header-actions__account-link');
    if ( $wrapper_login.hasClass('double-login') ) {
      e.preventDefault();
      e.stopImmediatePropagation();
      
      let state_block = $wrapper_trigger_login.attr('data-block-double-login');
      

      if (state_block == 'close'){
        $wrapper_trigger_login.attr('data-block-double-login','open');
      } else {
        $wrapper_trigger_login.attr('data-block-double-login','close');
      }
    }
  });

  //On ferme le block si click à l'extérieur
  $(document).on("click", function (event) {
    var $target = $(event.target); // Élément cliqué

    // Vérifie si l'élément cliqué est en dehors du bloc
    if (!$target.closest("#double-login-wrapper").length && $("#double-login-wrapper").is(":visible")) {
      $('.site-header-actions.double-login').attr('data-block-double-login','close'); 
    }
  });
  
  // Si on est en page Collection
  if ($('body').hasClass('template-collection')) {
    if ($('.productgrid--filters').length !== 0) {
      $('ul.active-filter-group').children().not('.active-filter-group--remove-all').each(function(){
        let filter_value = $(this).find('.active-filter-text').data('filter-label');
        let filter_class_to_add = `filter-${filter_value}`;
        $('.productgrid--filters').addClass(filter_class_to_add);
      });
    }

  }
  
  // Si on est en page Produit
  if ($('body').hasClass('template-product')) {

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Fonction pour ajuster la position de #product-menu-anchor-trigger et stocker les hauteurs
    
    let headerHeightRaw, headerHeight, triggerHeight, anchorOffset, detectionPoint;
    let navigation_exist = false;
    
    function adjustTriggerPosition() {
      headerHeightRaw = $('header.site-header .site-header-main').outerHeight();
      if ($('header.site-header').hasClass('site-header-sticky--scrolled')) { headerHeight = headerHeightRaw; } else { headerHeight = headerHeightRaw - 10; }
      triggerHeight = $('#product-menu-anchor-trigger').outerHeight();
      anchorOffset = $('#product-menu-anchor').offset().top + 70;
      detectionPoint = headerHeight + triggerHeight + 40;
      $('#product-menu-anchor-trigger').css('top', headerHeight);
    }
    
    if ($('#product-menu-anchor-trigger').length !== 0 && $('#product-menu-anchor').length !== 0) {
  
      // Création du menu pour chaque section
      $('.product-detail-section').each(function(index) {
        let section = $(this).find('> section');
        let sectionId = section.attr('id');
        let sectionName = section.find('.image-with-text__section-heading').text();
          
        if (sectionId && sectionName) {
          navigation_exist = true;
          $('#product-menu-anchor-trigger ul').append(`<li><a href="#${sectionId}">${sectionName}</a></li>`);
          $('#product-menu-anchor ul').append(`<li><a href="#${sectionId}">${sectionName}</a></li>`);
        } else {
          $(this).remove();
        }

        if(navigation_exist == false) {
          $('.shopify-section.product-navigation').remove();
        }
      });
  
  
      const trigger = $('#product-menu-anchor-trigger');
  
      // Fonction pour activer les sections dans le menu
      function activateMenuItems() {
        let scrollPos = $(window).scrollTop();
        
        // Vérifier si l'une des trois sections spécifiées est présente et calculer leur position
        let footerSection = $('.product-recommendations--section, .recently-viewed--section, .shopify-section-group-footer-group').first();
        let footerSectionTop = footerSection.length ? footerSection.offset().top : null;
      
        // Ajouter ou retirer la classe "visible" pour #product-menu-anchor-trigger en fonction du scroll
        if (scrollPos > anchorOffset && (!footerSectionTop || scrollPos < footerSectionTop)) {
          trigger.addClass('visible');
        } else {
          trigger.removeClass('visible');
        }
      
        // Activer la classe active dans le menu en fonction du scroll
        $('.product-detail-section').each(function() {
          let section = $(this).find('> section');
          if (section.length) {
            let sectionTop = section.offset().top - detectionPoint;
            let sectionBottom = sectionTop + section.outerHeight();
      
            let sectionId = section.attr('id');
            let menuItems = $(`#product-menu-anchor-trigger a[href="#${sectionId}"], #product-menu-anchor a[href="#${sectionId}"]`).parent();
      
            if (scrollPos >= sectionTop && scrollPos < sectionBottom) {
              menuItems.addClass('active').siblings().removeClass('active');
            }
          }
        });
      }

  
      // Défilement doux lors des clics
      $('#product-menu-anchor-trigger a, #product-menu-anchor a').on('click', function(e) {
        e.preventDefault();
        let targetId = $(this).attr('href');
        let targetPosition = $(targetId).offset().top - headerHeight - triggerHeight - 30;
  
        $('html, body').stop().animate({ scrollTop: targetPosition }, 500);
      });

      if (navigation_exist) {
        // Activation des sections lors du scroll
        $(window).on('scroll', activateMenuItems);
    
        // Appel initial pour synchroniser le menu dès le chargement complet
        $(window).on('load', activateMenuItems, adjustTriggerPosition);
      }
    }


  
  
      //////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      //Affichage dynamique des metafields variante 
        
        //On jour la fonction au chargement de la page
          
        redirectToOtherFormat();
        updateVariantDetail();
        updateVariantLinkPreview();
        updateVariantMainTitle();
        //sortOptionsDropdownVariant();
        generateVariantFilters();
        applyVariantFilter(false);

        //On rejoue la fonction à chaque changement de variante select
        $('.options-selection__input-select-wrapper').change(function() {
          updateVariantDetail();
          updateVariantLinkPreview();
          updateVariantMainTitle();
         });
        //On rejoue la fonction à chaque changement de variante radio
        $('.options-selection__option-values').on('click', function(){
          updateVariantDetail();
          updateVariantLinkPreview();
          updateVariantMainTitle();
        });

        //On joue la fonction lorsque une sélection radio du filtre des variantes se produit
        $('#variant-filter .wrapper-filters.level input[type="radio"], #variant-filter .wrapper-filters.type input[type="radio"]').on('change', function(){
          applyVariantFilter(true);
        });

        function sortOptionsDropdownVariant() {
          // Cible le select contenant les options
          const selectElement = $('.options-selection__input-select-wrapper > select');
        
          // Récupérer toutes les options, les détacher pour éviter des erreurs d'affichage, puis trier par la "value"
          const optionsArray = selectElement.find('option').toArray();
          const sortedOptions = optionsArray.sort((a, b) => a.value.localeCompare(b.value));
        
          // Vider le select, puis réinsérer les options triées
          selectElement.empty().append(sortedOptions);
        }


       function applyVariantFilter(display_first_option) {
          // Récupérer les valeurs sélectionnées pour Level et Type
          const selectedLevel = $('.wrapper-filters.level input[type="radio"]:checked').val();
          const selectedType = $('.wrapper-filters.type input[type="radio"]:checked').val();
        
          // Vérifier si "Tous" est sélectionné pour Level ou Type
          const isLevelAll = selectedLevel === 'all';
          const isTypeAll = selectedType === 'all';
        
          // Masquer ou afficher les options en fonction des valeurs sélectionnées
          $('.options-selection__input-select-wrapper > select > option').each(function() {
            const optionLevel = $(this).data('level-title');
            const optionType = $(this).data('type');
        
            // Détermine si l'option doit être affichée ou non
            const matchesLevel = isLevelAll || optionLevel === selectedLevel;
            const matchesType = isTypeAll || optionType === selectedType;
        
            if (matchesLevel && matchesType) {
              $(this).prop('disabled', false).css('display', 'block'); // Active et affiche l'option
            } else {
              $(this).prop('disabled', true).css('display', 'none'); // Désactive et cache l'option
            }
          });

         // Détecter si l'URL contient "?variant="
          const urlParams = new URLSearchParams(window.location.search);
          const variantId = urlParams.get("variant");
          
          // Sélectionner la première option visible
          const selectElement = document.querySelector('.options-selection__input-select-wrapper > select');
          const firstVisibleOption = Array.from(selectElement.options).find(option => option.style.display !== 'none');


         //SI il existe une premiere variante
          if (firstVisibleOption) {

            //Si il n'y a pas de variant dans l'URL OU si c'est la fonction est jouée lors d'un click bouton alors on affiche la première variant affichée dans le menu déroulant
            if (variantId == null || display_first_option) {
            
            // Définir la première option visible comme sélectionnée
            selectElement.value = firstVisibleOption.value;
        
            // Créer des événements de changement et d’entrée (input)
            const changeEvent = new Event('change', { bubbles: true });
            const inputEvent = new Event('input', { bubbles: true });
        
            // Déclencher les deux événements pour assurer la détection
            selectElement.dispatchEvent(changeEvent);
            selectElement.dispatchEvent(inputEvent);
            }
            
          }
         
        }

        function redirectToOtherFormat() {
          $('#variant-filter .wrapper-filters.format input[type="radio"]:not(:checked)').on('click', function(e){
            var main_domain = window.location.hostname;
            var final_link = "";
            var param_level = "";
            var param_type = "";
            var value_level_option = $('#variant-filter .wrapper-filters.level input[type="radio"]:checked').data('param');
            var value_type_option = $('#variant-filter .wrapper-filters.type input[type="radio"]:checked').data('param');
            var link_to_redirect = $(this).data('link');
            var product_link = 'https://'+main_domain+'/products/'+link_to_redirect;
            if (value_level_option) {
              param_level = 'level='+value_level_option;
            }
            if (value_type_option) {
              if (value_level_option) { param_type = "&"; }
              param_type += 'type='+value_type_option;
            }
            if (value_level_option || value_type_option) {
              product_link += '?';
            }
            final_link = product_link + param_level + param_type;
            
            //Redirige la page
            window.location.href = final_link;
          });
          
          
        }
            
        //Fonction qui génère dynamiquement les valeurs radio selon les options de variantes existantes
        function generateVariantFilters() {
          // Tableaux uniques pour les valeurs de data-level et data-type
          let levelValues = [];
          let typeValues = [];
          
          // Parcours de chaque option pour récupérer les valeurs data-level et data-type
          $('.options-selection__input-select-wrapper > select > option').each(function() {
            const level = $(this).data('level-title');
            const type = $(this).data('type');
            
            // Ajoute les valeurs uniques dans levelValues
            if (level && $.inArray(level, levelValues) === -1) {
              levelValues.push(level);
            }
            
            // Ajoute les valeurs uniques dans typeValues
            if (type && $.inArray(type, typeValues) === -1) {
              typeValues.push(type);
            }
          });

          // Trie les tableaux en ordre ascendant
          levelValues.sort();
          // Fonction de tri
          typeValues.sort((a, b) => {
            if (a === "Élève" || a === "Student") {
              return -1; // a en première position
            } else if (b === "Élève" || b === "Student") {
              return 1; // b en première position
            }
            return 0; // Pas de changement sinon
          });
          
          // Générer les boutons radio pour chaque niveau unique
          const levelWrapper = $('#variant-filter .wrapper-filters.level');
          levelValues.forEach(function(level) {
            let level_displayed = level;
            //if (level.indexOf('Primaire') || level.indexOf('Secondaire') || level.indexOf('Primary') || level.indexOf('Secondary')) {
            //  level_displayed = level.replace(/^\S+\s*/, "");
            //}
            let param = handleize(level);
            
            const radioButton = `
              <label>
                <input
                  class="option-filter-variant-input"
                  type="radio"
                  name="Level"
                  data-param="${param}"
                  value="${level}"
                >
                <span class="label">${level_displayed}</span>
              </label>
            `;
            levelWrapper.append(radioButton);
          });
        
          // Générer les boutons radio pour chaque type unique
          const typeWrapper = $('#variant-filter .wrapper-filters.type');
          typeValues.forEach(function(type) {
            let param = handleize(type);
            
            const radioButton = `
              <label>
                <input
                  class="option-filter-variant-input"
                  type="radio"
                  name="Type"
                  data-param="${param}"
                  value="${type}"
                >
                <span class="label">${type}</span>
              </label>
            `;
            typeWrapper.append(radioButton);
          });

          // Détecter si l'URL contient "?variant="
          const urlParams = new URLSearchParams(window.location.search);
          const variantId = urlParams.get("variant");
          const levelOption = urlParams.get("level");
          const typeOption = urlParams.get("type");
          var hasParam = false;
          var delayDisplayBlock = 0;
      
          if (variantId) {
            
              // Rechercher l'élément avec data-variant-id égal à l'ID récupéré
              const targetItem = $('.options-selection__input-select-wrapper').children().find(`[data-variant-id="${variantId}"]`);
              const targetFirstItem = $('.options-selection__input-select-wrapper').children().first();
      
              if (targetItem.length > 0) {

                  //On le déplace en première position pour qu'il s'affiche dans le menu déroulant
                  //targetItem.insertBefore(targetFirstItem);
                
                  // Récupérer les valeurs de data-level-title et data-type
                  const levelTitle = targetItem.data("level-title");
                  const type = targetItem.data("type");
      
                  // Simuler un clic sur les <input> correspondants pour les rendres highlighted
                  $(`.wrapper-filters.level input[value="${levelTitle}"]`).prop('checked', true);
                  $(`.wrapper-filters.type input[value="${type}"]`).prop('checked', true);
                
              }
          } else {
            
               //Si aucun param de variant ID n'est trouvé dans l'URL
                //On vérifie qu'il n'y a pas d'autre param (lien JS pour les formats Num et Papier)

              if (levelOption || typeOption) {
                hasParam = true;
                
                setTimeout(function() {

                  //Si on trouve quelque chose dans l'URL
                  if (levelOption) {
                    var $button_level_target = $('#variant-filter .wrapper-filters.level input[type="radio"][data-param="'+levelOption+'"]');
                    if ($button_level_target.length > 0) {
                      $button_level_target.trigger('click');
                    } else {
                      $('#variant-filter .wrapper-filters.level input[type="radio"]').trigger('click');
                    }
                  //Sinon on clique le premier bouton
                  } else {
                    $('#variant-filter .wrapper-filters.level input[type="radio"]').trigger('click');
                  }
                  if (typeOption) {
                    var $button_type_target = $('#variant-filter .wrapper-filters.type input[type="radio"][data-param="'+typeOption+'"]');
                    if ($button_type_target.length > 0) {
                      $button_type_target.trigger('click');
                    } else {
                      $('#variant-filter .wrapper-filters.type input[type="radio"]').trigger('click');
                    }
                  } else {
                    $('#variant-filter .wrapper-filters.type input[type="radio"]').trigger('click');
                  }
                }, 900);
              } else {
                
                //Sinon, on sélectionne par défaut les deux premiers boutons radio de chaque groupe 
                $('#variant-filter .wrapper-filters.level input[type="radio"]').first().trigger('click');
                $('#variant-filter .wrapper-filters.type input[type="radio"]').first().trigger('click');
              }
          }


          //On dévoile le bloc
          if (hasParam) { delayDisplayBlock = 1000; }
          
          setTimeout(function() {
            $('#variant-filter .wrapper-filters.format, #variant-filter .wrapper-filters.level, #variant-filter .wrapper-filters.type').removeClass('hidden');
          }, delayDisplayBlock);
        }

        function updateVariantLinkPreview(){
          setTimeout(function() {
            const variant_id_selected = $('.variant-selection__variants').val();
            
            $('#product-links > .link-variant-preview').each(function(){
              let variant_id = $(this).data('variant-id');
              if (variant_id == variant_id_selected) {
                $(this).removeClass('hidden');
              } else {
                $(this).addClass('hidden');
              }
              //Pour afficher le lien ISSUU du produit (quand il n'y a pas de lien ISSUU par variante)
              /*if ($(this).hasClass('product-link')){
                $(this).removeClass('hidden');
              }*/
            });
          }, 100);
        }

      function updateVariantMainTitle() {
        var $items_variant = null;
        
        //On regarde dans le DOM si le changement de variant se fait par select ou radio
        if ($('.options-selection__select-wrapper').length != 0) {
          $items_variant = $('.options-selection__input-select-wrapper > select').children();
        } else if ($('.options-selection__option-values').length != 0 ) {
          $items_variant = $('.options-selection__radios .options-selection__option-value');  
        } else {
          $items_variant = null;
        }

        //On décale un petit peu la récup d'info sinon ne laisse pas le temps au select de se mettre à jour
          setTimeout(function() {

            //On récupère l'id variant sélectionné
            const variant_id_selected = $('.variant-selection__variants').val();
            
              //On met à jour le champs du titre produit
              $items_variant.each(function(){
                let data_group_level = "";
                let data_variant_id = $(this).data('variant-id');
                if (variant_id_selected == data_variant_id ) {
                  let data_group_level = $(this).data('level-title');
      
                  //On l'injecte dans le titre
                  if (data_group_level != "") {
                    if ($('.product-title').find('.variant-matiere').length != 0) {
                      $('.product-title').find('.variant-group-level').text(' - '+data_group_level);
                    } else {
                     $('.product-title').find('.variant-group-level').text(data_group_level); 
                    }
                  } else {
                    $('.product-title').find('.variant-group-level').text('');
                  }
                }
              });
          }, 100);
        
      }
  
        //On met à jour les champs de détails
        function updateVariantDetail() {  
          const $variant_bloc = $('#variant-details');
          const $variant_items = $variant_bloc.find('li.variant-item');

          //On décale un petit peu la récup d'info sinon ne laisse pas le temps au select de se mettre à jour
          setTimeout(function() {

            //On récupère l'id variant sélectionné
            const variant_id_selected = $('.variant-selection__variants').val();
            
            //On met à jour le bloc d'infos
            $variant_items.each(function(){
              let data_variant_id = $(this).data('id-variant');
              if(variant_id_selected == data_variant_id){
                $variant_items.addClass('hidden');
                $(this).removeClass('hidden');
              }
            }); 
          }, 100);
      }
    
  } //END IF ('body').hasClass('template-product')

  //END Document READY
});

//Ajoute l'attribut "src" aux iframes, car supprimée par le script du thème et empêche le bon fonctionnement
 document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('iframe[data-src]').forEach((iframe) => {
      if (!iframe.getAttribute('src') && iframe.dataset.src) {
        console.log('Restauration du src Youtube');
        iframe.setAttribute('src', iframe.dataset.src);
      }
    });
  });
  